import { render, staticRenderFns } from "./MovementBulkUpdate.vue?vue&type=template&id=5a1f0b38&"
import script from "./MovementBulkUpdate.vue?vue&type=script&lang=js&"
export * from "./MovementBulkUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports